export const mediaProperty = (
  assetType,
  windowSize,
  isVideoPaused,
  useNewAspectRatioBehavior = false,
) => {
  if (assetType === 'image') {
    if (useNewAspectRatioBehavior) {
      return {
        property: windowSize.width > 767 ? 'imageUrlLandscape' : 'imageUrlPortrait',
        label: windowSize.width > 767 ? 'Image (Landscape) - Asset' : 'Image (Portrait) - Asset',
      };
    }

    return {
      property: windowSize.width > 767 ? 'imageUrlLarge' : 'imageUrlSmall',
      label: windowSize.width > 767 ? 'Image (Landscape) - Asset' : 'Image (Portrait) - Asset',
    };
  }
  if (assetType === 'video' && isVideoPaused) {
    return {
      property: windowSize.width > 767 ? 'posterImageUrlLarge' : 'posterImageUrlSmall',
      label:
        windowSize.width > 767
          ? 'Poster image (Landscape) - Asset'
          : 'Poster image (Portrait) - Asset',
    };
  }
  return {
    property: windowSize.width > 767 ? 'videoUrlLarge' : 'videoUrlSmall',
    label: windowSize.width > 767 ? 'Video (Landscape) - Asset' : 'Video (Portrait) - Asset',
  };
};
